import { PartnerWhiteLabelMetadata } from "../../Contracts/ClientPortalMetadata";
import { create } from "zustand";
import { useRequestStore } from "../BackendStore";
import { persist } from "zustand/middleware";

const getClientPortalMetadataUrl = "/v1/payments/client-portal";
const postLoginClientPortalUrl = "/v1/payments/client-portal/login";

interface ClientPortalMetadataState {
  isLoading: boolean;
  partnerWhiteLabelMetadata?: PartnerWhiteLabelMetadata;
  getClientPortalMetadata: (uuid: string) => Promise<void>;
  postLoginClientPortal: (uuid: string, email: string) => Promise<void>;
  clientPortalToken?: string;
  clientPortalUUID?: string;
  setClientPortalTokenAndUUID: (token: string, uuid: string) => void;
}

export const useClientPortalMetadataStore = create<ClientPortalMetadataState>()(
  persist(
    set => {
      const { getRequestNoAuth, postRequestNoAuth } = useRequestStore.getState();

      const getClientPortalMetadata = async (uuid: string) => {
        set({ isLoading: true });
        const response = await getRequestNoAuth<PartnerWhiteLabelMetadata>(
          getClientPortalMetadataUrl,
          { uuid }
        );
        set({
          partnerWhiteLabelMetadata: response,
          isLoading: false
        });
      };

      const postLoginClientPortal = async (uuid: string, email: string) => {
        set({ isLoading: true });
        try {
          await postRequestNoAuth<{ uuid: string; email: string }, {}>(postLoginClientPortalUrl, {
            uuid,
            email
          });
        } catch (error) {
          console.error(error);
          throw error;
        } finally {
          set({ isLoading: false });
        }
      };

      const setClientPortalTokenAndUUID = (clientPortalToken: string, clientPortalUUID: string) => {
        set({ clientPortalToken, clientPortalUUID });
      };

      return {
        isLoading: true,
        allowedPaymentMethods: {},
        getClientPortalMetadata,
        postLoginClientPortal,
        setClientPortalTokenAndUUID
      };
    },
    {
      name: "client-portal-metadata",
      partialize: state => ({
        clientPortalToken: state.clientPortalToken,
        partnerWhiteLabelMetadata: state.partnerWhiteLabelMetadata,
        clientPortalUUID: state.clientPortalUUID
      })
    }
  )
);
